import(/* webpackMode: "eager", webpackExports: ["DynamicProviders"] */ "/opt/build/repo/apps/hestia/src/components/ui/DynamicProviders/index.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Roboto\",\"arguments\":[{\"weight\":[\"100\",\"300\",\"400\",\"500\",\"700\",\"900\"],\"subsets\":[\"latin\"]}],\"variableName\":\"font\"}");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/apps/hestia/src/styles/globals.scss");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/@polkadex/ux/dist/index.css");
